<template>
<div class="invoice-list">
  <error-cant-reach-server :errorData="errorData"  class="mt-2 mr-2 ml-2" v-if="isCantReach" @clickCTA="populateList()"></error-cant-reach-server>
  <div class="container text-center">
    <div class="spinner-border text-primary text-center m-4" role="status" v-if="isLoading">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <ul class="list-group list-group-flush">
    <li class="list-group-item list-group-item p-4" v-for="invoice in invoices" :key="'invoice-' + invoice.id">
      <div class="row">
          <div class="col-1 p-0">
              <p v-if="invoice.isPaid" class="bullet-dot text-success">•</p>
              <p v-else class="bullet-dot text-danger">•</p>
          </div>
          <div class="col-5 pl-2">
              <p class="m-0">
                <!-- งวดที่ {{invoice.periodDisplay || invoice.periodNum}}/{{invoices.length}} -->
                 งวดที่ {{invoice.periodDisplay || invoice.periodNum}}
              </p>
              <p v-if="invoice.isPaid" class="m-0 text-secondary"><small>จ่ายแล้ว
                
                <template v-if="invoice.isPostpone == 1">
                  (ชำระพร้อมดอกเบี้ยปรับ)
                </template>
                <template v-if="invoice.isPostpone == 2">
                  (ชำระเฉพาะเงินต้น กรณีผ่อนผัน)
                </template>
              
              </small></p>
              <p v-else class="m-0 text-secondary"><small>ยังไม่จ่าย</small></p>
          </div>
          <div class="col-6 text-right">

              <template v-if="invoice.isPostpone == 0">
                <p v-if="invoice.isPaid" class="m-0 text-success">{{invoice.total | money}}</p>
                <p v-else class="m-0 text-danger">{{invoice.total | money}}</p>
              </template>
              <template v-if="invoice.isPostpone == 1">
                <p v-if="invoice.isPaid" class="m-0 text-success">{{invoice.total | money}}</p>
                <p v-else class="m-0 text-danger">{{invoice.total | money}}</p>
              </template>
              <template v-if="invoice.isPostpone == 2">
                <p v-if="invoice.isPaid" class="m-0 text-success">{{invoice.total | money}}</p>
                <p v-else class="m-0 text-danger">{{invoice.total | money}}</p>
              </template>
              

              <p v-if="contractType == 'MORTGAGE'" class="m-0 text-secondary"><small>ชำระแล้วเมื่อ {{$dayjs(invoice.paidDate).format('D MMM')}}</small></p>
              <p v-else class="m-0 text-secondary"><small>กำหนดชำระ {{$dayjs(invoice.dueDate).format('D MMM')}}</small></p>

          </div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  data: () => ({
    isLoading: false,
    isCantReach: false,
    errorData: {},
    invoices: []
  }),
  async created () {
    await this.populateList()
  },
  methods: {
    async populateList() {
      this.list = []
      this.isLoading = true
      let result;
      result = await this.$api.contract.getInvoices(this.contractId);
      console.log("pao here");
      console.log(result);
      const data = result.data
      if (!data.success) {
        this.isCantReach = true
        this.errorData = data
        return
      }
      this.invoices = data.invoices
      this.isLoading = false
    },
  },
  props: {
    contractId: {
      type: Number,
      default: -1,
      required: true
    },
    contractType: {
      type: String,
      default: "MONEY",
      required: true
    },
  }
}
</script>

<style lang="scss">
</style>
